export default function checkValueOfEmpty(value: unknown, withEmptyString = false): boolean {
    return (
        value !== undefined &&
        value !== null &&
        ((!withEmptyString && value !== '') || withEmptyString)
    );
}
